import { connect } from 'react-redux';
import {
  trackNewbuildingFromTheBuilderBlockAppearance,
  trackTransferToNewbuildingFromTheBuilder,
} from '../../actions/analytics/trackNewbuildingFromDeveloper';
import { INewbuildingFromTheBuilderProps, NewbuildingFromTheBuilder } from '../../components/NewbuildingFromTheBuilder';
import { getBuilders, getNewbuldingFromTheBuilder, getNewbuldingFromTheBuilderLink } from '../../selectors/newbuilding';
import { TApplicationState } from '../../types/redux';
import { getGaLabel } from '../../selectors/analytics';
import { getUser } from '../../selectors/user';
import { getAnalyticsRegionId } from '../../actions/analytics';

export function mapStateToProps(state: TApplicationState): INewbuildingFromTheBuilderProps {
  const builders = getBuilders(state);
  const newbuildings = getNewbuldingFromTheBuilder(state);
  const gaLabel = getGaLabel(state);
  const user = getUser(state);
  const regionId = getAnalyticsRegionId(state);

  return {
    newbuildings: getNewbuldingFromTheBuilder(state),
    newbuildingsLink: getNewbuldingFromTheBuilderLink(state),
    trackNewbuildingFromTheBuilderBlockAppearance: () => {
      trackNewbuildingFromTheBuilderBlockAppearance({
        builders,
        newbuildings,
        gaLabel,
        user,
        regionId,
      });
    },
    trackTransferToNewbuildingFromTheBuilder: (index: number) => {
      trackTransferToNewbuildingFromTheBuilder({
        index,
        builders,
        newbuildings,
        gaLabel,
        user,
        regionId,
      });
    },
  };
}

export const NewbuildingFromTheBuilderContainer = connect(mapStateToProps)(NewbuildingFromTheBuilder);
